import React, { Fragment, useEffect, useState } from 'react';
import connect from 'react-redux/lib/connect/connect';
import { GetNoticeList } from '../../common/actions/moreAction';
import { dateFormation, isEmpty, isMobilePage } from '../../common/cores';
import Pagenation from '../common/Pagenation';
import BackButton from './BackButton';

const NoticeContent = (props) => {

    const { page, notices } = props;
    const [showHis, setShowHis] = useState(false);
    // const [ notice , setNotice ] = useState({})
    const [active, setActive] = useState(-1);

    const showHisotry = () => {
        setShowHis(!showHis);
    }
    const getMessage = (page) => {

        if (page > 0) {
            const params = {
                page: page,
                perPage: 10
            }
            props.GetNoticeList(params);
        }
    }

    const localNotices = !isEmpty(JSON.parse(localStorage.getItem("noticeList"))) ? JSON.parse(localStorage.getItem("noticeList")) : [];

    const onNotice = (index) => {
        // setNotice(notices[index]);
        if(active === index) {
            setActive(-1)
        }
        else{
            setActive(index)
        }
        
        showHisotry();
        
        if(!isEmpty(localNotices)){
            const noticeIndex = localNotices.findIndex(localNotice => localNotice === notices[index]._id);
            if(noticeIndex < 0){
                localStorage.setItem("noticeList", JSON.stringify([...localNotices, notices[index]._id]));
            }
        }
        else{
            localStorage.setItem("noticeList", JSON.stringify([notices[index]._id]));
        }
    }

    const notice = notices[active];

    useEffect(() => {
        getMessage(1);
    }, [])
    return (

        <div className="contents_wrap">
            <div className="contents_box">
                <div className="con_box00">
                    <table width="100%" border="0" cellSpacing="0" cellPadding="0" style={{borderSpacing: "0px"}}>
                        <tbody>
                            <tr>
                                <td width="13%" className="list_title1">번호</td>
                                <td className="list_title1">제목</td>
                                <td width="10%" className="list_title1">상태</td>
                                <td width="10%" className="list_title1">날짜</td>
                            </tr>
                            {!isEmpty(notices) &&
                                notices.map((item, index) => {
                                    return (
                                        <Fragment key={index}>
                                        <tr key={index}>
                                            <td className="list1">{isNaN(page.curPage) ? 0 : Number(page.curPage - 1) * 10 + index + 1}</td>
                                            <td className="list1" onClick={()=>onNotice(index)}><span className="font06" dangerouslySetInnerHTML={{ '__html': !isEmpty(item.title) ? item.title : "" }}></span></td>

                                            <td className={`list1 ${localNotices.findIndex(notice => notice === item._id) < 0 ? "red-color" : "blue-color"}`}>
                                                { localNotices.findIndex(notice => notice === item._id) < 0 ? "미확인" : "확인" }
                                            </td>
                                            <td className="list1">{!isEmpty(item.created_date) && dateFormation(item.created_date)}</td>
                                        </tr>
                                        { active === index && 
                                            <tr>
                                                <td colSpan="4" style={{borderBottom: "1px solid rgba(255, 255, 255, 0.1)", width: "100%", textAlign: "center"}} >
                                                    <div className="notice-div white-break-spaces" dangerouslySetInnerHTML={{'__html': item.content}}></div>
                                                </td>
                                            </tr>}
                                        </Fragment>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>

                <Pagenation page={page.curPage}
                    totalPage={page.totalPage}
                    getPage={getMessage}
                    perPage={10} />
            </div>
        </div>
    )
}

const mapStateToProps = state => ({
    page: state.page,
    notices: state.more.notice.notices
})

export default connect(mapStateToProps, { GetNoticeList })(NoticeContent);


// WEBPACK FOOTER //
// ./src/components/account/NoticeContent.js